/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import CustomDropdown from "./CustomDropdown/CustomDropdown"; // Import the custom dropdown
import styles from "./FileUpload.module.css";
import uploadIcon from "../icons/upload.svg";
import api from "../Api";
import { useEffect } from "react";
import WarningModal from "../WarningModal/WarningModal";
import ShowDataTable from "../ShowDataTable/ShowDataTable";
import Loader from "../Loader/Loader.js";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { Grid, Typography } from "@material-ui/core";
const normalHeaders = [
  "#",
  "File name",
  "Category",
  "Status",
  "Uploaded For",
  "Emission Factor",
  "Actions",
  "Last updated by",
  "Last updated on",
];

const getDefaultHeaders = () => ({
  "x-tenant-schema": "Amplo111",
  "x-user-id": localStorage.getItem("UserId") || ""
});

const isAdmin = localStorage.getItem("UserType") == 1;

const FileUpload = ({ categories, handleFileUpload, applyClass }) => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [fileInfo, setFileInfo] = useState(null);
  const modifiedCategories = categories
    ? [...categories, { name: "Unknown Data Category" }]
    : [{ name: "Unknown Data Category" }];
  const [categorySelected, setCategorySelected] = useState(null);
  const [templateSelected, setTemplateSelected] = useState(null);
  const [mappingKeySelected, setMappingKeySelected] = useState(null);
  const [templates, setTemplates] = useState(null);
  const [mappingKeys, setMappingKeys] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const fileInputRef = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  const userID = queryParams.get("userID");
  const [type, setType] = useState("0");
  const [isLoading, setIsLoading] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [entities, setEntities] = useState([]);
  const [operatingUnits, setOperatingUnits] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("");

  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedUploadLevel, setSelectedUploadLevel] = useState("company");
  const [selectedLevelItem, setSelectedLevelItem] = useState(null);
  const [selectedEntityId, setSelectedEntityId] = useState("");
  const [selectedFuelType, setSelectedFuelType] = useState(null);
  const [selectedElectricityGrid, setSelectedElectricityGrid] = useState(null);
  const [selectedElectricitySource, setSelectedElectricitySource] = useState(null);
  const [electricityGrids, setElectricityGrids] = useState([]);


  const fetchTemplatesForCategory = async () => {
    setLoader1(true);
    try {
      const res = await api.post(
        `/getTemplatesForCategory?userID=${userID}`,
        categorySelected,
      );
      setTemplates([...res.data, { name: "No template available" }]);
    } catch (err) {
      console.log(err);
    }
    setLoader1(false);
  };
  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const userEmail = sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || "";
        const res = await api.get("/getAllCompanies", {
          headers: {
            ...getDefaultHeaders(),
            "x-user-email": userEmail
          }
        });
        let companies = res.data?.data || [];

        // FILTER by Project Selection Context if available
        if (userEmail && userEmail.toLowerCase() === "superadmin@amplo.com") {
          const projectSelectionStr = sessionStorage.getItem("projectSelection");
          if (projectSelectionStr) {
            try {
              const projectSelection = JSON.parse(projectSelectionStr);
              if (projectSelection.client && projectSelection.client.company_id) {
                const contextCompanyId = String(projectSelection.client.company_id);
                const contextCompany = companies.find(c => String(c.company_id) === contextCompanyId);
                if (contextCompany) {
                  companies = [contextCompany];
                }
              } else if (projectSelection.ampProject && projectSelection.ampProject.CompanyID) {
                const contextCompanyId = String(projectSelection.ampProject.CompanyID);
                const contextCompany = companies.find(c => String(c.company_id) === contextCompanyId);
                if (contextCompany) {
                  companies = [contextCompany];
                }
              }
            } catch (e) {
              console.error("Error parsing project selection:", e);
            }
          }
        }

        const industrySet = new Set();
        // Company list
        setCompanies(companies);

        // Entity list
        const allEntities = companies.flatMap((company) =>
          company.entity_level_industry_mappings?.map((entity) => ({
            ...entity,
            company_id: company.company_id,
            company_name: company.name,
          })) || []
        );
        setEntities(allEntities);

        // Operating unit list
        const allUnits = companies.flatMap((company) => {
          const companyUnits = company.company_level_operating_units?.map((unit) => ({
            ...unit,
            company_id: company.company_id,
            company_name: company.name,
            type: "unit-company",
          })) || [];

          const entityUnits = company.entity_level_operating_units?.map((unit) => ({
            ...unit,
            company_id: company.company_id,
            company_name: company.name,
            entity_id: unit.entity_id,
            entity_name: unit.entity_name,
            type: "unit-entity",
          })) || [];

          return [...companyUnits, ...entityUnits];
        });
        setOperatingUnits(allUnits);



        companies.forEach((company) => {
          if (Array.isArray(company.company_level_industry_mappings)) {
            company.company_level_industry_mappings.forEach((m) => {
              if (Array.isArray(m.industry)) {
                m.industry.forEach((i) => {
                  industrySet.add(JSON.stringify(i));
                });
              }
            });
          }

          if (Array.isArray(company.entity_level_industry_mappings)) {
            company.entity_level_industry_mappings.forEach((entity) => {
              if (Array.isArray(entity.industry)) {
                entity.industry.forEach((i) => {
                  industrySet.add(JSON.stringify(i));
                });
              }
            });
          }

          if (Array.isArray(company.operating_units)) {
            company.operating_units.forEach((unit) => {
              if (unit.industry) {
                industrySet.add(unit.industry);
              }
            });
          }
        });

        setIndustries(Array.from(industrySet).sort());
      } catch (err) {
        console.error("Error fetching metadata:", err);
      }
    };

    fetchMeta();
    fetchElectricityGrids();
  }, []);


  const fetchMappingKey = async () => {
    setLoader2(true);
    try {
      const res = await api.post("/getMappingKeyForTemplate", templateSelected);
      setMappingKeys([...res.data, { name: "No mapping key available" }]);
    } catch (err) {
      console.log(err);
    }
    setLoader2(false);
  };

  const fetchElectricityGrids = async () => {
    try {
      const res = await api.get("/electricity/station-name", {
        headers: getDefaultHeaders(),
      });
      const grids = res.data?.data || [];
      setElectricityGrids(grids.map(g => ({ name: g.station_name })));
    } catch (err) {
      console.error("Error fetching electricity grids:", err);
    }
  };

  useEffect(() => {
    if (templateSelected) {
      if (templateSelected.name === "No template available") return;
      fetchMappingKey();
    }
  }, [templateSelected]);

  useEffect(() => {
    if (categorySelected) {
      if (categorySelected.name === "Unknown Data Category") return;
      fetchTemplatesForCategory(categorySelected);
    }
  }, [categorySelected]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    let levelType = "";
    let levelId = "";
    let companyId = "";
    let industryId = "";
    let entityId = "";

    if (selectedUploadLevel === "company") {
      levelType = "company";
      levelId = selectedLevel.split("-")[1];
      const company = companies.find((c) => `company-${c.company_id}` === selectedLevel);
      companyId = company?.company_id || "";

      const industries = company?.company_level_industry_mappings?.flatMap(m => m.industry) || [];
      if (industries.length === 1) {
        industryId = industries[0]?.industry_id;
      } else {
        const selectedIndustryObj = industries.find((i) => i.industry_id === selectedIndustry);
        industryId = selectedIndustryObj?.industry_id || "";
      }

    } else if (selectedUploadLevel === "entity") {
      levelType = "entity";
      levelId = selectedLevel.split("-")[1];
      const entity = entities.find((e) => `entity-${e.entity_id}` === selectedLevel);
      companyId = entity?.company_id || "";

      const industries = entity?.industry || [];
      if (industries.length === 1) {
        industryId = industries[0]?.industry_id;
      } else {
        const selectedIndustryObj = industries.find((i) => i.industry_id === selectedIndustry);
        industryId = selectedIndustryObj?.industry_id || "";
      }

    } else if (selectedUploadLevel === "unit") {
      levelType = "unit";
      levelId = selectedLevel.split("-")[1];
      const unit = operatingUnits.find((u) => `unit-${u.unit_id}` === selectedLevel);

      if (unit) {
        if (unit.entity_id) {
          entityId = unit.entity_id;
          const parentEntity = entities.find((e) => e.entity_id === unit.entity_id);
          companyId = parentEntity?.company_id || unit?.company_id || "";
        } else {
          companyId = unit?.company_id || "";
        }

        const industryMatch = industries.find(i => i.industry_name === unit?.industry_tag);
        industryId = industryMatch?.industry_id || "";
      }
    }

    const payload = {
      selectedFile,
      categorySelected,
      templateSelected,
      mappingKeySelected,
      level: levelType,
      levelId,
      companyId,
      industryId,
      entityId,
      selectedFuelType,
      selectedElectricityGrid,
      selectedElectricitySource
    };
    console.log(payload);
    handleFileUpload(payload);
    e.target.value = null;
  };



  const formatDate = (isoDate) => {
    return new Date(isoDate).toLocaleString("en-US", {
      year: "numeric",
      month: "short", // "Feb"
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Use 12-hour format with AM/PM
    });
  };

  const fetchUploadedFiles = async () => {
    setIsLoading(true);
    try {
      const res = await api.post("/getUploadedFiles", { userID, isAdmin });
      const transformedData = res.data.files.map((file) => {
        let emissionFactorDisplay = "Not applicable";

        if (file && file.category_name) {
          const cat = file.category_name.toLowerCase();

          if (cat.includes("fuel")) {
            emissionFactorDisplay = file.fuel_type || "Fuel type not provided";
          } else if (cat.includes("electricity")) {
            if (file.electricity_source && file.electricity_grid) {
              emissionFactorDisplay = `${file.electricity_source}: ${file.electricity_grid}`;
            } else if (file.electricity_grid) {
              emissionFactorDisplay = file.electricity_grid;
            } else {
              emissionFactorDisplay = "Electricity Grid: Not provided";
            }
          }
        }

        return [
          file && file.file_id || '',
          file && file.filename || '',
          file && file.category_name || 'Unknown',
          file && file.status || 'Unknown',
          file && file.upload_for || '-',
          emissionFactorDisplay,
          "Actions",
          file && file.updated_by || 'Admin',
          formatDate(file && file.updated_at || '')
        ];
      });
      setData(res.data.files);
      setFileInfo(transformedData);
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUploadedFiles();
  }, []);

  const handleUploadClick = () => {
    if (
      categorySelected?.name === "Unknown Data Category" ||
      templateSelected.name === "No template available"
    ) {
      setShowWarning(true);
      return;
    }
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = async (id) => {
    setIsLoading(true);
    try {
      const res = await api.post("/deleteUploadedFile", { id, userID });
      const transformedData = res.data.files.map((file) => {
        return [
          file.file_id,
          file.filename,
          file.category_name || "Unknown",
          file.status,
          file.upload_for,
          "Actions",
          file.updated_by || "Admin",
          formatDate(file.updated_at),
        ];
      });
      setData(res.data.files);
      setFileInfo(transformedData);
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  if (isLoading || loader1 || loader2) {
    return <Loader />;
  }

  const industryIdResolved = () => {
    if (selectedLevel?.startsWith("unit")) {
      return true;
    }
    return !!selectedIndustry;
  };

  return (
    <div className={styles.fileUploadCont}>
      <p className={styles.disc}>
        <b>Tip :</b> Select upload level, corresponding company/entity/unit, and industry. Then choose the data category, template, and mapping key (if applicable) to upload data files.
      </p>
      <div className={styles.warningCont}>
        <div className={styles.warningBox}></div>
      </div>

      <div className={styles.dropdownContainer}>
        <Grid container spacing={2}>
          {/* Upload Level Select */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography><b>Select Level</b></Typography>
            <Select
              placeholder="Select Upload Level"
              options={[
                { label: "Select Level", value: "" },
                { label: "Company", value: "company" },
                { label: "Entity", value: "entity" },
                { label: "Operating Unit", value: "unit" },
              ]}
              value={
                selectedUploadLevel
                  ? {
                    label:
                      selectedUploadLevel === "company"
                        ? "Company"
                        : selectedUploadLevel === "entity"
                          ? "Entity"
                          : "Operating Unit",
                    value: selectedUploadLevel,
                  }
                  : { label: "Select Level", value: "" }
              }
              onChange={(option) => {
                setSelectedUploadLevel(option.value);
                setSelectedLevel("");
                setSelectedLevelItem(null);
                setSelectedIndustry("");
                setSelectedCompanyId("");
                setSelectedEntityId("");
                setIndustries([]);
              }}
            />
          </Grid>
          {/* ----------------------------- */}
          {/* Company Dropdown for 'entity' or 'unit' */}
          {["entity", "unit"].includes(selectedUploadLevel) && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography><b>Select Company</b></Typography>
              <Select
                placeholder="Select Company"
                options={[
                  { label: "Select Company", value: "" },
                  ...companies.map((c) => ({
                    label: c.name,
                    value: c.company_id,
                  })),
                ]}
                value={
                  selectedCompanyId
                    ? {
                      label: companies.find((c) => c.company_id === selectedCompanyId)?.name,
                      value: selectedCompanyId,
                    }
                    : { label: "Select Company", value: "" }
                }
                onChange={(option) => {
                  setSelectedCompanyId(option?.value || "");
                  setSelectedEntityId("");
                  setSelectedLevel("");
                  setSelectedLevelItem(null);
                  setIndustries([]);
                  setSelectedIndustry("");
                }}
              />
            </Grid>
          )}

          {/* ----------------------------- */}
          {/* Entity Dropdown for 'entity' or 'unit' */}
          {["entity", "unit"].includes(selectedUploadLevel) && selectedCompanyId && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography><b>Select Entity</b></Typography>
              <Select
                placeholder="Select Entity"
                options={[
                  { label: "Select Entity", value: "" },
                  ...entities
                    .filter((e) => e.company_id === selectedCompanyId)
                    .map((e) => ({
                      label: e.entity_name,
                      value: e.entity_id,
                    })),
                ]}
                value={
                  selectedEntityId
                    ? {
                      label: entities.find((e) => e.entity_id === selectedEntityId)?.entity_name,
                      value: selectedEntityId,
                    }
                    : { label: "Select Entity", value: "" }
                }
                onChange={(option) => {
                  const val = option?.value || "";
                  setSelectedEntityId(val);
                  const selectedEntity = entities.find((e) => e.entity_id === parseInt(val));
                  setSelectedLevelItem(selectedEntity);
                  if (selectedUploadLevel === "entity") {
                    setIndustries(selectedEntity?.industry || []);
                  }
                  setSelectedIndustry("");
                }}
              />
            </Grid>
          )}

          {/* ----------------------------- */}
          {/* Operating Unit Dropdown for 'unit' only */}
          {selectedUploadLevel === "unit" && selectedCompanyId && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography><b>Select Operating Unit</b></Typography>
              <Select
                placeholder="Select Operating Unit"
                options={[
                  { label: "Select Operating Unit", value: "" },
                  ...operatingUnits
                    .filter((ou) => {
                      if (selectedEntityId) {
                        return (
                          ou.entity_id === parseInt(selectedEntityId) ||
                          (ou.company_id === selectedCompanyId && !ou.entity_id)
                        );
                      }
                      return ou.company_id === selectedCompanyId && !ou.entity_id;
                    })
                    .map((ou) => ({
                      label: ou.name,
                      value: `unit-${ou.unit_id}`,
                    })),
                ]}
                value={
                  selectedLevel
                    ? {
                      label: selectedLevelItem?.name,
                      value: selectedLevel,
                    }
                    : { label: "Select Operating Unit", value: "" }
                }
                onChange={(option) => {
                  const val = option?.value || "";
                  if (!val) {
                    setSelectedLevel("");
                    setSelectedLevelItem(null);
                    return;
                  }
                  const id = parseInt(val.split("-")[1]);
                  const selected = operatingUnits.find((ou) => ou.unit_id === id);
                  setSelectedLevel(val);
                  setSelectedLevelItem(selected);
                  setIndustries([selected?.industry].filter(Boolean));
                  setSelectedIndustry("");
                }}
              />
            </Grid>
          )}

          {/* Generic Level Selection Dropdown for company/entity (non-unit) */}
          {selectedUploadLevel === "company" && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography><b>Select Company</b></Typography>
              <Select
                placeholder="Select Company"
                options={[
                  { label: "Select Company", value: "" },
                  ...companies.map((c) => ({
                    label: c.name,
                    value: `company-${c.company_id}`,
                  })),
                ]}
                value={
                  selectedLevel
                    ? {
                      label: selectedLevelItem?.name,
                      value: selectedLevel,
                    }
                    : { label: "Select Company", value: "" }
                }
                onChange={(option) => {
                  const val = option?.value || "";
                  setSelectedLevel(val);
                  const id = val.split("-")[1];
                  const selected = companies.find((c) => c.company_id === parseInt(id));
                  setSelectedLevelItem(selected);
                  setIndustries(
                    selected?.company_level_industry_mappings?.flatMap((m) => m.industry) || []
                  );
                  setSelectedIndustry("");
                }}
              />
            </Grid>
          )}

          {/* Industry Dropdown */}
          {industries.length > 0 && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography><b>Select Industry</b></Typography>
              <Select
                placeholder="Select Industry"
                options={[
                  { label: "Select Industry", value: "" },
                  ...industries.map((ind) => ({
                    label: ind.industry_name,
                    value: ind.industry_id,
                  })),
                ]}
                value={
                  selectedIndustry
                    ? industries
                      .map((ind) => ({
                        label: ind.industry_name,
                        value: ind.industry_id,
                      }))
                      .find((opt) => opt.value === selectedIndustry)
                    : { label: "Select Industry", value: "" }
                }
                onChange={(option) => setSelectedIndustry(option?.value)}
              />
            </Grid>
          )}
        </Grid>
      </div>

      <div className={styles.dropdownContainer}>
        <CustomDropdown
          label="Select Data Category"
          options={modifiedCategories}
          header="Select data category"
          whichDropdown="1"
          type={type}
          setType={setType}
          value={categorySelected?.name || ""}
          onSelect={(value) => {
            setCategorySelected(value);
            setTemplateSelected(null);
            setMappingKeySelected(null);
          }}
          disabled={false}
        />

        <CustomDropdown
          label="Select Data Template"
          options={templates}
          header="Select data template"
          whichDropdown="2"
          type={type}
          setType={setType}
          value={templateSelected?.name || ""}
          onSelect={(value) => {
            setTemplateSelected(value);
            setMappingKeySelected(null);
          }}
          disabled={
            !categorySelected ||
            categorySelected?.name === "Unknown Data Category"
          }
        />

        <CustomDropdown
          label="Select Mapping Key"
          options={mappingKeys}
          header="Select mapping key"
          whichDropdown="3"
          type={type}
          setType={setType}
          value={mappingKeySelected?.name || ""}
          onSelect={(value) => setMappingKeySelected(value)}
          disabled={
            !templateSelected ||
            templateSelected?.name === "No template available"
          }
        />
      </div>
      {/* Conditionally show additional dropdowns based on categorySelected */}
      {categorySelected?.name?.toLowerCase().includes("fuel") && (
        <div className={styles.dropdownContainer}>
          <Grid item xs={12} sm={6} md={4}>
            <CustomDropdown
              label="Select Fuel Type"
              options={[
                { name: "Acetylene" },
                { name: "Aviation Fuel (Jet A1)" },
                { name: "Coal (Bituminous)" },
                { name: "Diesel" },
                { name: "Furnace Oil" },
                { name: "HSD (Travel)" },
                { name: "LPG" },
                { name: "Petrol" }
              ]}
              header="Select Fuel"
              whichDropdown="fuel"
              type={type}
              setType={setType}
              value={selectedFuelType?.name || ""}
              onSelect={(value) => setSelectedFuelType(value)}
              disabled={false}
            />
          </Grid>
        </div>
      )}

      {categorySelected?.name?.toLowerCase().includes("electricity") && (
        <div className={styles.dropdownContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <CustomDropdown
                label="Select Electricity Source"
                options={[
                  { name: "Electricity Grid" },
                ]}
                header="Select Electricity Source"
                whichDropdown="electricity-source"
                type={type}
                setType={setType}
                value={selectedElectricitySource?.name || ""}
                onSelect={(value) => setSelectedElectricitySource(value)}
                disabled={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomDropdown
                label="Select Electricity Grid"
                options={electricityGrids}
                header="Select Electricity Grid"
                whichDropdown="electricity-grid"
                type={type}
                setType={setType}
                value={selectedElectricityGrid?.name || ""}
                onSelect={(value) => setSelectedElectricityGrid(value)}
                disabled={false}
              />
            </Grid>
          </Grid>
        </div>
      )}


      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {showWarning ? (
        <WarningModal
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="#D6746F"
              className="bi bi-info-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
          }
          onCancel={() => setShowWarning(false)}
          onSave={() => fileInputRef.current.click()}
          okButton="Continue"
          cancelButton="Cancel"
          color="#D6746F"
          message="Request admin to create data category and template if it doesn’t exist. Proceed only if unknown."
        />
      ) : null}

      <button
        className={styles.uploadButton}
        disabled={
          !selectedLevel ||
          !(
            categorySelected?.name === "Unknown Data Category" ||
            (templateSelected && templateSelected?.name !== "No template available")
          )
        }
        onClick={handleUploadClick}
      >
        <img src={uploadIcon} alt="Upload Icon" className={styles.uploadIcon} />
        Upload
      </button>


      <ShowDataTable
        // Configuration flags
        showBackButton={false}
        showSaveCancelButton={false}
        showSaveButton={false}
        showSorting={true}
        showMatching={false}
        showTitle={false}
        showSearchFilter={true}
        showMappingTip={false}
        shouldSlice={true}
        sectionType={"Data File"}
        onDelete={handleDelete}
        // Step & state management
        currentStep={0}
        isFileUploaded={1}
        isDataEditable={false}
        isTemplateSection={false}
        isHomeSection={true}
        // Data
        categories={categories?.map((cat) => cat?.name)}
        fileInfo={data}
        headerData={normalHeaders}
        extractedData={fileInfo}
        // // Styling
        ApplyClass={applyClass}
        searchPlaceholder={"Search File Name"}
      />
    </div>
  );
};

export default FileUpload;
